import React, { useEffect, useState } from 'react';
import { faPencilAlt, faLockOpen, faCheck } from '@fortawesome/free-solid-svg-icons';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import Stepper from '../../../components/Stepper/Stepper';
import Funcionalidades from './components/Funcionalidades';
import FormularioUsuario from './components/FormularioUsuario';
import FichaUsuarioContainer from './components/FichaUsuarioContainer';
import Loading from '../../../components/Loading/Loading';

//Api
import usuario_api from '../../../api/usuario_api';


//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';

//Estado inicial do usuario
function initialStateUsuario() {
    return {
        nome: "",
        cpfcnpj: "",
        status: "Ativo",
        cargo: "",
        telefone: "",
        matricula: "",
        email: "",
        perfil: "",
        permissoes: [],
        setores: []
    }
}

export default function NovoUsuario({ btnVoltar, usuarioParam = {} }) {
    //Estado que guarda os dados do usuario a ser Adicionado/Editado
    const [usuario, setUsuario] = useState(Object.keys(usuarioParam).length > 0 ? usuarioParam : initialStateUsuario);

    //Estado que guarda os erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Estado que guarda o passo ativo do stepper
    const [activeStep, setActiveStep] = useState(1);

    //Estado que controla o loading na tela
    const [loading, setLoading] = useState(false);




    //Campos obrigatorios do cadastro de usuario
    const camposFormulario = [
        objCampo({ name: "nome", required: true }),
        objCampo({ name: "status", required: true }),
        objCampo({ name: "cpfcnpj", required: true, cpfcnpj: true }),
        objCampo({ name: "email", required: true, email: true }),
        objCampo({ name: "perfil", required: true }),
    ]

    //Valida os campos para passar para o proximo passo no stepper
    const validarFormulario = () => {
        const _errors = validarCampos(usuario, camposFormulario);
        setErrors(_errors[0]);
        return _errors[1];
    }

    //Passos do stepper
    const [steps, setSteps] = useState([
        { text: "Identificação do usuário", icon: faPencilAlt, validateStep: validarFormulario },
        { text: "Módulos - Acessos", icon: faLockOpen },
        { text: "Finalizar", icon: faCheck },
    ]);


    //Retorna o conteudo do passo ativo
    function getSteps() {
        if (usuario?.perfil == "Integrador Externo") {
            switch (activeStep) {
                case 1: {
                    return (
                        <FormularioUsuario
                            usuario={usuario}
                            setUsuario={setUsuario}
                            campos={camposFormulario}
                            errorsParam={errors}
                        />
                    )
                }
                case 2: {
                    return <FichaUsuarioContainer
                        usuario={{ ...usuario }}
                        editUsuario={() => setActiveStep(1)}
                        editAcessos={() => setActiveStep(2)}
                    />
                }
            }
        } else {
            switch (activeStep) {
                case 1: {
                    return (
                        <FormularioUsuario
                            usuario={usuario}
                            setUsuario={setUsuario}
                            campos={camposFormulario}
                            errorsParam={errors}
                        />
                    )

                }
                case 2: {
                    return (
                        <Funcionalidades
                            usuario={usuario}
                            setUsuario={setUsuario}
                        />
                    )
                }
                case 3: {
                    return <FichaUsuarioContainer
                        usuario={{ ...usuario }}
                        editUsuario={() => setActiveStep(1)}
                        editAcessos={() => setActiveStep(2)}
                    />
                }
            }
        }
    }

    //Cadastra/Edita um usuario
    function onSubmitUsuario() {
        setLoading(true);
        const _usuario = { ...usuario, setores: usuario.setores.map(value => { return { tbSetores_Id: value.value, descricaoSetor: value.label } }) };
        if (!usuario.id) {
            usuario_api.post(_usuario).then(response => {
                setUsuario(response.data);
                showMessage("Sucesso", "Sucesso ao cadastrar o usuario", "success", btnVoltar);
            }).catch(e => {
                showMessage("Aviso", e.message, "error");
            }).finally(f => setLoading(false));
        } else {
            usuario_api.put(_usuario).then(response => {
                setUsuario(response.data);
                showMessage("Sucesso", "Sucesso ao editar o usuario", "success", btnVoltar);
            }).catch(e => {
                showMessage("Aviso", e.message, "error");
            }).finally(f => setLoading(false));
        }
    }

    useEffect(() => {
        if (usuario?.perfil == "Integrador Externo")
            setSteps([
                { text: "Identificação do usuário", icon: faPencilAlt, validateStep: validarFormulario },
                { text: "Finalizar", icon: faCheck }
            ]);
        else if (usuario?.perfil != "Integrador Externo")
            setSteps([
                { text: "Identificação do usuário", icon: faPencilAlt, validateStep: validarFormulario },
                { text: "Módulos - Acessos", icon: faLockOpen },
                { text: "Finalizar", icon: faCheck }
            ]);
    }, [usuario]);

    return (
        <>
            {loading && <Loading />}
            <MainCard btnVoltar={btnVoltar}>
                <Stepper
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    onSubmit={onSubmitUsuario}
                >
                    {getSteps()}
                </Stepper>
            </MainCard>
        </>
    )
}